/**
 * 产品基本信息Tab组件
 * 包含：核心信息、尺寸重量、品牌名称、产品描述、分站点关键词
 */

import React from 'react';
import { Card, Form, Row, Col, Input, InputNumber, Select, Divider, FormInstance } from 'antd';
import { SiteKeywordsEditor, SITE_OPTIONS } from '../SiteKeywordsEditor';
import { STATUS_OPTIONS } from './constants';

const { TextArea } = Input;

interface Brand {
    id: number;
    name: string;
    tone?: string;
}

interface BasicInfoTabProps {
    form: FormInstance;
    brands: Brand[];
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ form, brands }) => {
    return (
        <Card bordered={false}>
            <Form form={form} layout="vertical">
                <Divider orientation="left">核心信息</Divider>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item name="name" label="SKU名称" rules={[{ required: true }]}>
                            <Input placeholder="SKU名称" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="asin" label="ASIN">
                            <Input placeholder="ASIN (10位)" maxLength={10} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="sku_code" label="SKU编码">
                            <Input placeholder="SKU编码" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="status" label="状态">
                            <Select options={STATUS_OPTIONS as any} placeholder="选择状态" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="site" label="站点">
                            <Select options={SITE_OPTIONS} placeholder="选择站点" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="category" label="类目">
                            <Input placeholder="产品类目" />
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left">产品尺寸与重量</Divider>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item name="length" label="长度 (cm)">
                            <InputNumber min={0} step={0.1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name="width" label="宽度 (cm)">
                            <InputNumber min={0} step={0.1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name="height" label="高度 (cm)">
                            <InputNumber min={0} step={0.1} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name="weight" label="重量 (kg)">
                            <InputNumber min={0} step={0.01} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left">品牌与名称</Divider>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item name="brand_obj" label="品牌">
                            <Select
                                placeholder="选择品牌"
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                options={brands.map(b => ({
                                    value: b.id,
                                    label: b.name,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="name_cn" label="中文名称">
                            <Input placeholder="中文名称" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="name_en" label="英文名称">
                            <Input placeholder="英文名称" />
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left">产品描述</Divider>
                <Row gutter={24}>
                    <Col span={24}>
                        <Form.Item name="description" label="产品描述">
                            <TextArea rows={4} placeholder="输入产品描述..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left">分站点核心关键词</Divider>
                <Form.Item
                    name="site_keywords"
                    tooltip="为各站点设置核心关键词，用于Listing优化和文案生成"
                >
                    <SiteKeywordsEditor />
                </Form.Item>
            </Form>
        </Card>
    );
};

export default BasicInfoTab;
